import { notification } from 'antd'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { SupplierPurchaseOrder } from '../../types'
import { MaterialsApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los materiales',
  })
}

const useMaterials = (purchaseOrders?: SupplierPurchaseOrder[]) => {
  const { data, isLoading } = useQuery([QUERY_KEYS.MATERIALS], () => MaterialsApi.getMaterials(), {
    staleTime: Infinity,
    onError,
  })

  const materialsOptions = useMemo(() => {
    const materialsAux = data
      ?.map(material => ({
        label: material.nameShort.concat(' ', material.sapCode.replace(/^(0+)/g, '')),
        value: material.id,
      }))
      .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))
    if (!!purchaseOrders?.length) {
      return materialsAux?.filter(material =>
        purchaseOrders.some(po => material.value === po.material.id),
      )
    }
    return materialsAux
  }, [data, purchaseOrders])

  return {
    materials: data,
    materialsOptions,
    isLoading,
  }
}

const useMaterialsBySupplier = (supplierCode: number | undefined) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.MATERIALS, { supplierCode }],
    () => MaterialsApi.getMaterialsBySupplier(supplierCode),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    materials: data,
    isLoading,
  }
}

const usePurchaseOrdersByMaterial = (
  supplierCode: number | undefined,
  plantId?: string | undefined,
) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.PURCHASES, { plantId, supplierCode }],
    () => MaterialsApi.getPurchaseOrdersByMaterial(supplierCode, plantId),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    purchaseOrders: data,
    isLoading,
  }
}

const useGroupsMaterial = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.GROUPS_MATERIAL],
    MaterialsApi.getByGroupsMaterial,
    {
      staleTime: Infinity,
      onError,
    },
  )

  const groupsMaterial = data
    ?.map(group => ({
      label: group.name,
      value: group.id,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))

  return {
    groupsMaterial,
    isLoading,
  }
}

export { useGroupsMaterial, useMaterials, useMaterialsBySupplier, usePurchaseOrdersByMaterial }
